import {TRAFFIC_CHANGE_URL} from '../constants';
import {TrafficChangeWorkerResponse} from '../typings';
import {useFetchWorker} from './use-fetch-worker';

export const useTrafficChange = () => {
  return useFetchWorker<TrafficChangeWorkerResponse>(TRAFFIC_CHANGE_URL);
};
